<template>
  <section class="search-query">
    <label>{{ label }} <span v-if="dateUpdate !== undefined">({{ dateUpdate }})</span></label>
    <b-button size="sm" :href="exportUrl + (label === 'SEO Ключи' ? 'seoww' : 'ppcww') + '/export/' + brandId" target="_blank" class="but-copy ml-1">
      Выгрузить в XLS
    </b-button>
    <b-button size="sm" v-if="!isCopyToClipboard" class="but-copy" v-on:click="setToClipboard">
      Копировать
    </b-button>
    <b-button v-if="update !== undefined" size="sm" class="mr-1 but-copy" v-on:click="update">
      Обновить
    </b-button>
    <b-card class="search-card">
      <b-textarea v-model="clipboardText" v-if="isCopyToClipboard" ref="clipboardRef"></b-textarea>
      <b-container fluid v-if="!isCopyToClipboard">
        <b-row>
          <b-col cols="3"><span style="float: left;">Ключ</span></b-col>
          <b-col><span>Языки</span></b-col>
          <b-col cols="2"><span style="float: right;">Общ Google</span></b-col>
          <b-col cols="2"><span style="float: right;">Общ Yandex</span></b-col>
          <b-col cols="2"><span style="float: right;">Фраз Yandex</span></b-col>
          <b-col cols="1"><span style="float: right;">Проверка</span></b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <b-row v-if="noData">
          <b-col cols="12">
            Нет ключей
          </b-col>
        </b-row>
        <b-row v-for="ruQuery in searchQueries" v-bind:key="ruQuery.id">
          <b-col class="search-name-box">
            <b-container fluid>
              <b-row>
                <b-col cols="3" class="text-left pl-0">
                  <i
                      v-if="isEditQueries[ruQuery.id] == undefined || !isEditQueries[ruQuery.id]"
                      v-on:click="editQueries(ruQuery.id)"
                  >{{ ruQuery.query }}</i>
                  <b-input
                      v-model="searchQueries[ruQuery.id]['query']"
                      v-show="isEditQueries[ruQuery.id] != undefined && isEditQueries[ruQuery.id]"
                      v-on:change="editQueries(ruQuery.id, true)"
                      :ref="'editQueries_'+ ruQuery.id"
                      size="sm"
                      class="mb-1"
                      v-if="searchQueries[ruQuery.id] != undefined"
                      v-on:focusout="handleFocusout(ruQuery.id)"
                  ></b-input>
                  <label class="red-text" v-if="duplicateQueriesEdit[ruQuery.id]">дубликат</label>
                </b-col>
                <b-col>
                  <i
                      v-if="isEditQueries[ruQuery.id] == undefined || !isEditQueries[ruQuery.id]"
                      v-on:click="editQueries(ruQuery.id)"
                  >{{ ruQuery.languages }}</i>
                  <b-input
                      v-model="searchQueries[ruQuery.id]['languages']"
                      v-show="isEditQueries[ruQuery.id] != undefined && isEditQueries[ruQuery.id]"
                      v-on:change="editQueries(ruQuery.id, true)"
                      :ref="'editQueriesLang_'+ ruQuery.id"
                      size="sm"
                      class="mb-1"
                      v-if="searchQueries[ruQuery.id] != undefined"
                      v-on:focusout="handleFocusout(ruQuery.id)"
                  ></b-input>
                </b-col>
                <b-col cols="2" class="text-right">{{ nFormat(ruQuery.frequency) }}</b-col>
                <b-col v-if="label !== 'SEO Ключи'" cols="4" class="text-right">{{ nFormat(ruQuery.generalFrequency) }}</b-col>
                <b-col v-if="label === 'SEO Ключи' && existPhrase" cols="2" class="text-right">{{ nFormat(ruQuery.frequencyYandex) }}</b-col>
                <b-col v-if="label === 'SEO Ключи' && existPhrase" cols="2" class="text-right">{{ nFormat(ruQuery.phraseFrequencyYandex) }}</b-col>
                <b-col cols="1" class="text-right pr-4">
                  <input v-if="label === 'SEO Ключи'" type="checkbox" v-model="ruQuery.is_published" @change="change"/>
                </b-col>
                <b-col cols="1">
                  <button type="button" class="but-remove close b-form-tag-remove ml-1"
                          v-on:click="queryDelete(ruQuery.id)"
                          v-if="isEditQueries[ruQuery.id] == undefined || !isEditQueries[ruQuery.id]"
                  >×
                  </button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
        <b-row align-h="center" class="pt-3 mt-2 ml-2 mr-1 create-row">
          <b-col cols="7">
            <label class="duplicate-label red-text" v-if="duplicateQueries">дубликат</label>
            <b-textarea
                size="sm"
                class="mb-2 query-input"
                rows="1"
                v-model="newQueries"
                placeholder="Введите запрос"
            >
            </b-textarea>
          </b-col>
          <b-col>
            <multiselect
                v-model="selectedLanguages"
                :options="languages"
                label="name"
                track-by="id"
                :multiple="true"
                open-direction="top"
                :close-on-select="false"
                :show-labels="false"
                :clear-on-select="false"
                :searchable="true"
                size="sm"
            ></multiselect>
          </b-col>
          <b-col cols="1">
            <label v-if="label === 'SEO Ключи'" >Проверка</label>
            <input v-if="label === 'SEO Ключи'" type="checkbox" v-model="newQueriesIsPublished"/>
          </b-col>
          <b-col>
            <button @click="addNewQuery" type="button" class="btn btn-outline-secondary float-right">добавить</button>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {config} from "@/config";

export default {
  name: "SearchQuery",
  props: {
    searchQueries: Object,
    label: String,
    brandId: Number,
    change: Function,
    update: Function,
    dateUpdate: String,
    existPhrase: Boolean,
    typeRu: Boolean,
    languages: Array
  },
  components: {
    Multiselect,
    Vue
  },
  data() {
    return {
      isEditQueries: {},
      newQueries: null,
      duplicateQueries: false,
      clipboardText: '',
      isCopyToClipboard: false,
      duplicateQueriesEdit: {},
      selectedLanguages: [],
      newQueriesIsPublished: true,
      exportUrl: config.apiUrl + '/brand-semantics/',
    }
  },
  computed: {
    noData() {
      return  Object.keys(this.searchQueries).length === 0
    }
  },
  methods: {
    getMaxKey: function (object) {
      let maxKey = -1;
      for (let key in object) {
        if (parseInt(key) > maxKey) {
          maxKey = key;
        }
      }
      return maxKey;
    },
    addNewQuery: function () {
      let maxKey = this.getMaxKey(this.searchQueries);
      maxKey++;
      let newKey = maxKey;
      let queriesSplit = this.newQueries.split("\n");
      queriesSplit.forEach((val) => {
        if (val && val.trim() != '') {
          let langCodes = 'ww'
          if (this.selectedLanguages.length <= 2 && !this.selectedLanguages.find(l => l.code==='ww')) {
            let languages = this.selectedLanguages.map(lang => lang.code)
            langCodes = languages.toString()
          }

          let tabSplit = val.split("\t");
          if (this.duplicateCheck(tabSplit[0])) {
            this.duplicateQueries = false
            // merge existed queries
            for (let key in this.searchQueries) {
              if (this.searchQueries[key].query === tabSplit[0]) {
                let newLangCodes = this.searchQueries[key].languages + ',' + langCodes
                if (newLangCodes.includes('ww') || newLangCodes.split(',').length > 2) {
                  newLangCodes = 'ww'
                }
                this.searchQueries[key].languages = newLangCodes
              }
            }
            return
          }
          let generalFrequency = 0;
          let frequency = 0;
          if (tabSplit.length > 1) {
            generalFrequency = tabSplit[1];
          }
          if (tabSplit.length == 3) {
            frequency = tabSplit[2];
          }
          this.$set(this.searchQueries, newKey, {
            id: newKey,
            generalFrequency: generalFrequency,
            frequency: frequency,
            query: tabSplit[0],
            is_published: this.newQueriesIsPublished,
            isNew: true,
            languages: langCodes
          });
          newKey++;
        }
      });
      this.newQueries = null;
      this.selectedLanguages = [];
      this.newQueriesIsPublished = true;
      this.change();
    },
    editQueries: function (id, isStop = false) {
      if (isStop === false) {
        for (let key in this.duplicateQueriesEdit) {
          if (this.duplicateQueriesEdit[key]) {
            return false
          }
        }
      }
      if (isStop && this.duplicateCheck(this.searchQueries[id]['query'], id)) {
        this.$forceUpdate()
        return false;
      }
      for (let key in this.isEditQueries) {
        const isWW = this.searchQueries[id]['languages'].includes('ww') || this.searchQueries[id]['languages'].split(',').length > 2
        if(isWW) {
          this.searchQueries[id]['languages'] = 'ww'
        }
        this.$set(this.isEditQueries, key, false);
      }

      this.$set(this.isEditQueries, id, !isStop);
      this.$nextTick(() => {
        if (isStop) {
          this.change();
        }
        // this.$refs['editQueries_' + id][0].focus();
      });
    },
    queryDelete: async function (id) {
      for (let key in this.searchQueries) {
        if (key == id) {
          let buf = this.searchQueries;
          delete buf[key];
          this.$forceUpdate();
        }
      }
      this.change();
    },
    duplicateCheck: function (query, id = false) {
      let queriesSplit = query.split("\n");
      // self check
      for (let qKey1 in queriesSplit) {
        for (let qKey2 in queriesSplit) {
          let tabSplit1 = queriesSplit[qKey1].split("\t");
          let tabSplit2 = queriesSplit[qKey2].split("\t");
          if (tabSplit1[0] == tabSplit2[0] && qKey1 != qKey2) {
            this.duplicateQueries = true;
            return true;
          }
        }
      }
      for (let qKey in queriesSplit) {
        let tabSplit = queriesSplit[qKey].split("\t");
        for (let key in this.searchQueries) {
          if ((id != key || !id) && tabSplit[0] == this.searchQueries[key].query) {
            if (id !== false) {
              this.duplicateQueriesEdit[id] = true;
            } else {
              this.duplicateQueries = true;
            }

            return true;
          } else {
            if (id !== false) {
              this.duplicateQueriesEdit[key] = false;
            }
          }
        }
      }
      this.duplicateQueries = false;
      return false;
    },
    setToClipboard: async function () {
      this.clipboardText = '';
      this.isCopyToClipboard = true;
      await this.$nextTick();
      for (let key in this.searchQueries) {
        let val = this.searchQueries[key];
        this.clipboardText += val.query + "\t" + val.languages + "\t" + val.generalFrequency + "\t" + val.frequency + "\n";
      }
      await this.$nextTick();
      let textareaEl = this.$refs.clipboardRef.$el;
      textareaEl.select();
      textareaEl.setSelectionRange(0, 99999);
      try {
        document.execCommand('copy');
      } catch (err) {
        alert('Oops, unable to copy');
      }
      /* unselect the range */
      window.getSelection().removeAllRanges();
      this.isCopyToClipboard = false;
    },
    handleFocusout: function (id) {
      if (!this.duplicateCheck(this.searchQueries[id]['query'], id)) {
        this.isEditQueries[id] = false
      } else {
        this.$nextTick(() => {
          this.$refs['editQueries_' + id][0].focus();
        });
        return false;
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped>
.search-link-box.col-4 {
  flex: 0 0 30%;
  max-width: 30%;
}

.search-name-box.col-8 {
  flex: 0 0 70%;
  max-width: 70%;
}

.search-query button.but-remove:focus {
  outline: none;
}

/*.query-aria::-webkit-scrollbar {*/
/*    display: none;*/
/*}*/
/*.query-aria {*/
/*    -ms-overflow-style: none;  !* IE and Edge *!*/
/*    scrollbar-width: none;  !* Firefox *!*/
/*}*/

.search-query .query-input {
  height: 34px;
  width: 91%;
  margin-right: 5px;
  display: inline-block;
}

.but-add-queries {
  line-height: 34px;
}

.box-but-copy {
  text-align: right;
  margin-top: -8px;
  padding-right: 2px;
  margin-right: -9px;
  margin-bottom: 13px;
  position: sticky;
  top: 10px;
  z-index: 999;
  background: white;
  padding-top: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid;
}

.but-copy {
  float: right;
  margin-bottom: 5px;
}

label {
  text-align: left;
  margin: 0;
  float: left;
}

.search-card {
  width: 100%;
  /*max-height: 370px;*/
  /*overflow-y: auto;*/
}

.duplicate-label {
  margin-left: 32px;
  color: grey;
}

.red-text {
  color: red;
}

.create-row {
  border-top: 3px solid lightgray;
}
</style>